export default "__VITE_ASSET__ba925947__"